import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-empty-result',
  templateUrl: './empty-result.component.html',
  styleUrls: ['./empty-result.component.css']
})
export class EmptyResultComponent implements OnInit {

  @Input() image;
  @Input() imageWidth;
  @Input() imageDouble;
  @Input() imageFull;

  constructor() { }

  ngOnInit() {
  }

}
